<template>
  <el-dialog
    :title="title"
    append-to-body
    :visible="agencyDialogVisible"
    :close-on-click-modal="false"
    width="80%"
    @close="closeDialog"
  >
    <div>
      <SiruiSearch
        ref="agencyServiceRef"
        :query="agencyServiceData"
        labelWidth="110px"
        :columns="topColumn"
        :isQueryPanel="false"
        :rules="agencyDialogRules"
      ></SiruiSearch>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">{{
        this.$t('receivablesManageList.button.cancel')
      }}</el-button>
      <el-button type="primary" @click="save">{{
        this.$t('receivablesManageList.button.determine')
      }}</el-button>
    </span></el-dialog
  >
</template>

<script>
  import SiruiSearch from '@/components/SiruiSearch';
  import { addAgencyForm } from '../data';
  import { mapState } from 'vuex';
  import orderMixin from '../orderMixin.js';
  export default {
    name: 'addAgencyDialog',
    mixins: [orderMixin],
    props: [
      'agencyDialogVisible',
      'title',
      'isEdit',
      'editFormValue',
      'addContainerType',
      'contractCode',
    ],
    components: {
      SiruiSearch,
    },
    data() {
      return {
        addAgencyForm,
        agencyServiceData: {
          containerType: '',
          rentDate: '',
          tranStartDate: '',
          productName: '',
          remarks: '',
        },
      };
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo.userInfo,
      }),
      topColumn() {
        return this.addAgencyForm(this);
      },
      agencyDialogRules() {
        return {
          productName: [{ required: true, message: '货物名称必选', trigger: ['change', 'blur'] }],
        };
      },
    },
    created() {
      console.log(this.isEdit, 'this.isEdit');
      this.agencyServiceData.containerType = this.addContainerType;
      if (this.isEdit) {
        // 编辑
        this.getEditValue();
      }
    },
    mounted() {
      this.getParentProductList();
    },
    methods: {
      getEditValue() {
        console.log(this.editFormValue.containerType, '12222');
        const editValue = {
          containerType: this.editFormValue.containerType,
          rentDate: this.editFormValue.rentDate,
          tranStartDate: this.editFormValue.tranStartDate,
          productName: this.editFormValue.productName,
          remarks: this.editFormValue.remarks,
        };
        Object.assign(this.agencyServiceData, editValue);
      },
      closeDialog() {
        // this.agencyDialogVisible = false;
        Object.keys(this.agencyServiceData).forEach((item) => {
          this.agencyServiceData[item] = '';
        });
        this.$emit('closeDialog');
      },
      save() {
        this.$refs.agencyServiceRef.validate((valid) => {
          if (valid) {
            this.$emit('submit', this.agencyServiceData);
            this.closeDialog();
          }
        });
      },
      changeProductHandler(val) {
        console.log(val, '111111');
        this.agencyServiceData.productName = val;
        // this.agencyServiceData.productCode = val[0].parentProductNo;
      },
    },
  };
</script>
